//ajax
    let isAjax = true;
    function ghAjax(r) {
        const apiKey = 'd7c166d2ee6531c9f4ca2dca53863fae';
        const apiSecret = '1551170c324ea524fe8ad4b322872feb';
        const timestamp = Math.round(new Date().getTime()/1000).toString();
        let sign = CryptoJS.HmacSHA256(apiKey + timestamp, apiSecret);
        sign = CryptoJS.enc.Base64.stringify(sign);
        let baseUrl;
        baseUrl = 'https://global.genhigh.com/shopify/';
        // baseUrl = 'https://global.genhigh.com/test/shopify/';
        return new Promise(function(resolve, reject) {
            $.ajax({
                type: r.type || 'post',
                dataType: "json",
                url: baseUrl + r.api,
                data: r.data ? JSON.stringify(r.data) : {},
                contentType: 'application/json',
                headers: (r.headers || {
                    'request-id': timestamp,
                    'api-key': apiKey,
                    'timestamp': timestamp,
                    'sign': sign
                }),
                success: function(data) {
                    isAjax = true;
                    resolve(data);
                },
                error: function(request) {
                    console.log("Connection error");
                    isAjax = true;
                }
            });
        });
    }

  // blog导航效果
  document.getElementById("gbn_toggle_button").addEventListener("click", function() {
      const panel = document.getElementById("gbn_content");
      this.classList.toggle('toggle');
      if (panel.style.display === "block") {
          panel.style.display = "none";
      } else {
          panel.style.display = "block";
      }
  });